import { Component } from '@theme/component';

/**
 * Product carousel for the Pasquini product recommendations section. Unlike
 * the Pasquini Showcase (which swaps pre-rendered per-tab slides), there is
 * only one product list here (from Search & Discovery), already rendered —
 * this just initializes Swiper over it.
 *
 * @extends Component
 */
class PasquiniProductRecommendationsComponent extends Component {
  /** @type {any} */
  #swiper = null;

  connectedCallback() {
    super.connectedCallback();
    this.#waitForSwiper();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#destroySwiper();
  }

  /** @param {number} [attempt] */
  #waitForSwiper(attempt = 0) {
    if (typeof window.Swiper !== 'undefined') {
      this.#initSwiper();
      return;
    }

    if (attempt > 40) return;
    window.setTimeout(() => this.#waitForSwiper(attempt + 1), 50);
  }

  #initSwiper() {
    const swiperEl = this.querySelector('.pasquini-product-recommendations__swiper');
    if (!swiperEl) return;

    const slides = swiperEl.querySelectorAll('.swiper-slide');
    if (slides.length === 0) return;

    const prevButton = this.querySelector('.pasquini-product-recommendations__arrow--prev');
    const nextButton = this.querySelector('.pasquini-product-recommendations__arrow--next');
    const paginationEl = this.querySelector('.pasquini-product-recommendations__pagination');

    this.#swiper = new window.Swiper(swiperEl, {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 12,
      watchOverflow: true,
      navigation:
        prevButton && nextButton
          ? {
              prevEl: prevButton,
              nextEl: nextButton,
            }
          : undefined,
      pagination: paginationEl
        ? {
            el: paginationEl,
            type: 'progressbar',
          }
        : undefined,
      breakpoints: {
        750: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 16,
        },
      },
    });
  }

  #destroySwiper() {
    if (this.#swiper) {
      this.#swiper.destroy(true, true);
      this.#swiper = null;
    }
  }
}

customElements.define('pasquini-product-recommendations-component', PasquiniProductRecommendationsComponent);
